import { useState } from "react";
import Chart from "react-apexcharts";
import "./DashboardOverallSales.css";

const DashboardOverallSales = () => {
  const [sentinent, setSentinent] = useState("Eroupe");
  const [showSentinent, setShowSentinent] = useState(false);
  const [options] = useState({
    chart: {
      type: "bar",
      //   height: "200px",
      //   stacked: true,
      toolbar: {
        show: false,
      },
      events: {
        dataPointMouseEnter: function (event) {
          event.path[0].style.cursor = "pointer";
        },
      },
      fontFamily: "poppins",
    },
    grid: {
      padding: {
        top: 10,
        right: 20,
        bottom: -10,
        left: 10,
      },
      show: false, // you can either change hear to disable all grids
    },
    xaxis: {
      sentinent: ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"],
      labels: {
        //     formatter: function (value) {
        //       return value.toFixed(0) + " Days";
        //     },
        show: true,
        style: {
          colors: [
            "#757679",
            "#757679",
            "#757679",
            "#757679",
            "#757679",
            "#757679",
            "#757679",
          ],
        },
      },
    },
    yaxis: {
      labels: {
        formatter: function (value) {
          return "$" + value.toFixed(0) + "K";
        },
        style: {
          colors: [
            "#757679",
            "#757679",
            "#757679",
            "#757679",
            "#757679",
            "#757679",
            "#757679",
          ],
        },
        show: true,
      },
    },

    stroke: {
      colors: ["transparent"],
      width: 4,
    },
    plotOptions: {
      bar: {
        columnWidth: "70%",
        borderRadius: 5,
        barHeight: "20%",
      },
    },
    dataLabels: {
      enabled: false,
    },
    fill: {
      colors: ["#4339F2", "#077AFF", "#51BE56"],
    },
    legend: {
      position: "top",
      fontFamily: "poppins",
      labels: {
        colors: "#757679",
      },
      markers: {
        strokeWidth: 5,
        width: 15,
        height: 15,
        strokeColor: ["#4339F2", "#077AFF", "#51BE56"],
        radius: 20,
        fillColors: ["transparent", "transparent", "transparent"],
      },
    },
  });
  const [series] = useState([
    {
      name: "India",
      data: [44, 55, 41, 37, 22, 43],
    },
    {
      name: "France",
      data: [53, 32, 33, 52, 13, 43],
    },
    {
      name: "Portugal",
      data: [13, 43, 32, 33, 52, 13],
    },
  ]);
  const chooseDropdown = (e) => {
    setSentinent(e.target.value);
    setShowSentinent((showSentinent) => !showSentinent);
  };
  return (
    <div className="dashboardOverallSales">
      <div className="dashboardOverallSales__header flex-row">
        <h3>Overall Sales</h3>
        <div className="dashboardOverallSales__dropdown">
          <div
            className={`dropdown-container flex-row ${
              showSentinent && "expand"
            }`}
            onClick={() => setShowSentinent((showSentinent) => !showSentinent)}
          >
            <p>{sentinent}</p>
            <svg
              width="12"
              height="12"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M16 4L8 12L16 20"
                stroke="black"
                strokeWidth="4"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </div>
          <div
            className={`dropdown-item-container flex-column ${
              showSentinent && "expand"
            }`}
          >
            <label htmlFor="sentinentOne">
              <input
                type="radio"
                name="sentinent"
                id="sentinentOne"
                value="one"
                onChange={chooseDropdown}
              />
              one
            </label>
            <label htmlFor="sentinentTwo">
              <input
                type="radio"
                name="sentinent"
                id="sentinentTwo"
                value="two"
                onChange={chooseDropdown}
              />
              two
            </label>
            <label htmlFor="sentinentThree">
              <input
                type="radio"
                name="sentinent"
                id="sentinentThree"
                value="three"
                onChange={chooseDropdown}
              />
              three
            </label>
            <label htmlFor="sentinentFour">
              <input
                type="radio"
                name="sentinent"
                id="sentinentFour"
                value="four"
                onChange={chooseDropdown}
              />
              four
            </label>
            <label htmlFor="sentinentFive">
              <input
                type="radio"
                name="sentinent"
                id="sentinentFive"
                value="five"
                onChange={chooseDropdown}
              />
              five
            </label>
          </div>
        </div>
      </div>
      <Chart
        options={options}
        series={series}
        height="320"
        // width="600"
        type="bar"
        width={"100%"}
      />
    </div>
  );
};

export default DashboardOverallSales;
